import { OrderDetailsResponseDto, OrderResponseDto } from '@tiendanube/common';
import { PAYMENTS_REFUND_EXTERNAL_PARTNERS_TAG } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { useHasPermission } from '../../../../../Auth/hooks';
import { useOrderIsEdited } from '../index';
import { useNuvemPagoRedirect } from '../useNuvemPagoRedirect';

export interface Result {
  canBeRefundedThroughCancelForm: () => boolean;
  canBeRefundedThroughRefundForm: () => boolean;
  canBePartiallyRefunded: () => boolean;
}

function useCanBeRefunded(
  orderDetails: Pick<
    OrderDetailsResponseDto | OrderResponseDto,
    'payment'
  > | null,
): Result {
  const isEdited = useOrderIsEdited();
  const { isNuvemPagoPayment } = useNuvemPagoRedirect(
    orderDetails?.payment.gateway ?? '',
  );

  const paymentCanBeRefunded = orderDetails?.payment.canBeRefunded ?? false;
  const [hasRefundExternalPartnersTag] = useHasTags([
    PAYMENTS_REFUND_EXTERNAL_PARTNERS_TAG,
  ]);
  const isAllowedForUser = useHasPermission('refund_order');
  const isAllowedForPartner =
    hasRefundExternalPartnersTag || isNuvemPagoPayment();
  const isRefundAllowed =
    paymentCanBeRefunded &&
    isAllowedForUser &&
    isAllowedForPartner &&
    !isEdited;

  return {
    canBeRefundedThroughCancelForm: () => isRefundAllowed,
    canBeRefundedThroughRefundForm: () => isRefundAllowed,
    canBePartiallyRefunded: () =>
      isRefundAllowed && 'Nuvem Pago' !== orderDetails?.payment.gateway,
  };
}

export default useCanBeRefunded;
